"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutingReportFileSource = void 0;
exports.RoutingReportFileSource = {
    Google: "GOOGLE",
    Bot: "BOT",
};
//# sourceMappingURL=routing-report-file-source.js.map